import './CampaignLink.scss';
import { ucFirst } from '../Utils/caseconverters';
import classNames from 'classnames';

function CampaignLink({ colorTheme, href, title, light }) {
  const handleLinkOnClick = (title) => {
    window.dataLayer.push({
      "event": "CampaignButtonClick",
      "buttonText": title,
      "isAuthenticated": window.authenticated,
      "selectedBranch": undefined,
    });
  }

  return (
    <a className={classNames(
      "CampaignLink",
      `CampaignLink--${ucFirst(colorTheme)}`, {
      "CampaignLink--Light": light
    })}
      rel="noopener noreferrer"
      target="_blank"
      href={href}
      onClick={() => handleLinkOnClick(title)}
    >
      {title}
    </a>
  )
}

CampaignLink.defaultProps = {
  colorTheme: "",
  light: false,
};

export default CampaignLink;
